import React, { Component } from "react";
//// componentes reutilizables
import AuthService from '../../../services/login/auth.service';
import Titulo from "../../generico/TituloPagina";
import TecladoPin from "../../generico/TecladoPin";
import $ from "jquery";
import DatosSocio from "../../generico/DatosSocio";
import Popup from "react-popup";
import { mensajeExito } from "../../generico/MensajeSistemaToast";
import { trackPromise } from "react-promise-tracker";
import history from "../login/history";
import MensajeUsuario from "../../generico/MensajeUsuario";
import authService from "../../../services/login/auth.service";
import ConfigService from "../../../services/configuracion/ConfigService";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faFloppyDisk, faBroom} from "@fortawesome/free-solid-svg-icons";

export default class CambiarPinTransaccional extends Component {

    constructor(props) {

        super(props);

        this.enviar = this.enviar.bind(this);
        this.onChangePinAnterior = this.onChangePinAnterior.bind(this);

        this.mostrarInputPin = true;

        this.state = {
            pinAnterior: "",
            pinNuevo: undefined,
            pinConf: undefined,

            message: ""
        };

        this.initData();

    }

    notifiPopup = (titulo, mensaje) =>
        Popup.register({
            title: titulo,
            content: mensaje,
            buttons: {
                right: [
                    {
                        text: "Aceptar",
                        className: "success",
                        action: function () {
                            Popup.close();
                        },
                    },
                ],
            },
    });

    onChangePinAnterior(e) {

        $(document).ready(function () {

            $(".input-box").keypress(function (e) {

                if (e.which !== 8 && e.which !== 0 && (e.which < 48 || e.which > 57)) {

                    // $("#errmsg").html("Solo valores numéricos").show().fadeOut("slow");
                    return false;
                }

            });
        });
        this.setState({
            pinAnterior: e.target.value
        });
    }


    componentDidMount() {
    }

    initData = () => {
        this.verificaTienePin();
    };

    verificaTienePin() {
        trackPromise(
          AuthService.verificaTienePin().then((response) => {
            var data = JSON.stringify(response.data);
            var jData = JSON.parse(data);
            // codigo = 0  ya tiene pin activo
            // codigo = 1  ya tiene un pin con estado solicitado
            // codigo = 2  ya tiene un pin con estado rechazado
            // codigo = 3  ya tiene un pin con estado temporal
            // codigo = 4  no tiene pin
    
            if (jData.codigo !== 0) {
                this.mostrarInputPin = false;
                this.setState({
                    message: jData.mensaje,
                });
            }

          })
        );
    }

    enviar() {

        var msg = this.state.pinNuevo;
        if (this.state.pinNuevo === undefined) {
            Popup.queue(
                this.notifiPopup(
                    "Error",
                    "Ingrese el nuevo pin transaccional"
                )
            );
            return;
        }

        if (this.state.pinNuevo !== this.state.pinConf) {
            Popup.queue(
                this.notifiPopup(
                    "Error",
                    "No coinciden los pines ingresados"
                )
            );
            return;
        }
        if (msg.length !== 6) {
            Popup.queue(
                this.notifiPopup(
                    "Error",
                    "El pin debe contener 6 caracteres"
                )
            );
            return;
        }




        AuthService.cambiarPinTransaccional(this.state.pinAnterior, this.state.pinNuevo).then(
            (response) => {
                var jsonData = response.data;
                //console.log(jsonData)
                if (jsonData.codigoRetorno !== "0") {
                    Popup.queue(
                        this.notifiPopup(
                            "Error",
                            jsonData.mensajeRetorno
                        )
                    );
                    return;
                }

                // window.location.reload();
                mensajeExito("Cambio de Pin Transaccional exitoso")

            },

        );

    }

    limpiarTodo() {
        window.location.reload();

    }

    volver(){
        //history.push("/resumenGeneralSocio");
        history.push(ConfigService.getPathByName("resumenGeneralSocio")?.url);
        window.location.reload();
    }

    resetPin() {

        $.validator.setDefaults({
            submitHandler: () => {
                this.enviar();
            }
        });
        $("#idFormReset").submit(function (e) {
            e.preventDefault();

        }).validate(
            {
                rules: {
                    pinAnterior: {
                        required: true,

                    },


                },
                messages: {
                    pinAnterior: {
                        required: "Este campo es requerido",

                    },



                },
                errorElement: "span",
                errorPlacement: function (error, element) {
                    error.addClass("invalid-feedback");
                    element.closest(".form-group").append(error);
                },
                highlight: function (element, errorClass, validClass) {
                    $(element).addClass("is-invalid");
                },
                unhighlight: function (element, errorClass, validClass) {
                    $(element).removeClass("is-invalid");
                },
            });


    }

    pinNewValue = (value) => {
        this.setState({
            pinNuevo: value,
        });

    };

    pinConfValue = (value) => {
        this.setState({
            pinConf: value,
        });

    };

    render() {
        //console.log("el valor es: ", this.mostrarInputPin);
        if(this.mostrarInputPin === true){
            return (
                <div className="content-wrapper">
                    <Titulo texto="Cambiar PIN - Transferencia Interbancaria" />
                    <section className="content">
                        <form id="idFormReset">
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="card">
                                            <div className="card-header">
                                                <DatosSocio />
                                            </div>
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="callout callout-warning consideraciones">
                                                            <h5>Consideraciones</h5>
                                                            <p>Recuerde que su pin es exclusivamente para su uso personal, y que la misma sustituye a su firma,
                                                            siendo de su entera responsabilidad el uso de la misma. No la divulgue.
                                                            Eximo a la Universitaria Ltda. de toda responsabilidad y/o
                                                    reclamo que pudiere surgir eventualmente por las operaciones realizadas.</p>
                                                        </div>
                                                        {this.state.message && (
                                                            <div className="form-group">
                                                                <div className="alert alert-danger" role="alert">
                                                                    {this.state.message}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
    
                                                    <div className="col-md-6">
                                                        <div className="row">
                                                            <div className="col-12">
                                                                <div className="form-group">
                                                                    <label className="input-label-bold">Pin Anterior (6 dígitos) *</label>
                                                                    <input id="pinOld" type="password" className="input-box form-control" name="pinAnterior"
                                                                        maxLength={6}
                                                                        onChange={this.onChangePinAnterior}
                                                                        value={this.state.pinAnterior}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-lg-6 col-12 teclados">
                                                                <TecladoPin
                                                                    pinValue={this.pinNewValue.bind(this)}
                                                                    label="Nuevo Pin (6 dígitos) *"
                                                                />
                                                            </div>
                                                            <div className="col-lg-6 col-12 teclados">
                                                                <TecladoPin
                                                                    pinValue={this.pinConfValue.bind(this)}
                                                                    label="Confirmar Pin (6 dígitos) *"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card-footer">
                                                <div className="row">
                                                    <div className="col-lg-8 col-md-6 col-12">
                                                    <label className="input-label-bold-obligatorio float-left">
                                                    (*) Campos Obligatorios
                                                </label>
                                                    </div>
                                                    <div className="col-lg-2 col-md-3 col-12">
                                                    <button type="submit" className="btn btn-cu-quintary float-right btn-consulta" onClick={() => this.limpiarTodo()} ><FontAwesomeIcon icon={faBroom} /> Limpiar Todo</button>
                                                    </div>
                                                    <div className="col-lg-2 col-md-3 col-12"> 
                                                    <button type="submit" className="btn btn-cu-primary float-right" onClick={() => this.resetPin()}><FontAwesomeIcon icon={faFloppyDisk} /> Guardar</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </section>
                </div >
            );
        } else{
            return (
                <div className="content-wrapper">
                    <Titulo texto="Cambiar PIN - Transferencia Interbancaria" />
                    <section className="content">
                        <form id="idFormReset">
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="card">
                                            <div className="card-header">
                                                <DatosSocio />
                                            </div>
                                            <br></br>
                                            <div className="row justify-content-md-center">
                                                <div className="col-md-8">
                                                {this.state.message && (
                                                    <MensajeUsuario tipo="INFO"
                                                    titulo="Importante."
                                                    mensaje={this.state.message} />
                                                )}
                                                </div>
                                            </div>

                                            <div className="card-footer">
                                                <button type="submit" className="btn btn-cu-primary float-right" onClick={() => this.volver()}>Aceptar</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </section>
                </div >
            );
        }
        
    }
}